import { track } from '@src/services/analytics';
import React from 'react';
import styled from 'styled-components';
import { device } from '@src/common/breakpoints';
import { useAppDispatch } from '@src/core/hooks';
import { closeCartModal } from '@src/features/cart/store/cart';
import { Heading4, Heading6 } from '@src/fonts/typography/Typography';
import useTranslate from '@src/i18n/useTranslate';
import CloseIcon from '@src/icons/close-icon.svg';

const CartDetailsHeader = () => {
  const { i18n } = useTranslate();
  const dispatch = useAppDispatch();

  const closeModal = () => {
    track('cartCloseButtonClick');

    dispatch(closeCartModal());
  };

  return (
    <>
      <HeaderTitleContainer>
        <HeaderTitle>{i18n('cart_header')}</HeaderTitle>
        <HeaderCloseButton onClick={closeModal} role='button' aria-label={i18n('cart_closeCart')}>
          <CloseIcon />
        </HeaderCloseButton>
      </HeaderTitleContainer>
      <HorizontalBar />
    </>
  );
};

export default CartDetailsHeader;

const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HeaderCloseButton = styled.div`
  width: 26px;
  height: 26px;
  cursor: pointer;
  svg {
    width: 100%;
    height: 100%;
  }
`;
const HeaderTitle = styled.h2`
  ${Heading6}
  width: 12ch;
  && {
    color: black;
  }
  ${device.mobile} {
    ${Heading4}
  }
`;

const HorizontalBar = styled.hr`
  border-top: 1px solid #7c7c7c;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
  ${device.mobile} {
    margin-top: 24px;
  }
`;
